export default "__VITE_ASSET__589f17d2__"